export enum Player {
  AMAZON_IVS = 'amazonivs',
  BITMOVIN = 'bitmovin',
  BITMOVIN_PWX = 'bitmovin-pwx',
  CHROMECAST_SHAKA = 'chromecast-shaka',
  DASHJS = 'dashjs',
  HLSJS = 'hlsjs',
  HTML5 = 'html5',
  JW = 'jw',
  RADIANT = 'radiant',
  SHAKA = 'shaka',
  THEOPLAYER = 'theoplayer',
  VIDEOJS = 'videojs',
}
